"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _polished = require("polished");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Button = _interopRequireDefault(require("../../../Button"));

var _Grid = require("../../../Grid");

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FooterRow = (0, _styledComponents.default)(_Grid.Row).withConfig({
  displayName: "Footer__FooterRow",
  componentId: "quaplv-0"
})(["justify-content:center;text-align:center;width:100%;", ";"], function (_ref) {
  var media = _ref.theme.media;
  return media.medium(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    text-align: left;\n    justify-content: flex-end;\n  "])));
});
var FooterCol = (0, _styledComponents.default)(_Grid.Col).withConfig({
  displayName: "Footer__FooterCol",
  componentId: "quaplv-1"
})(["text-align:center;", ";"], function (_ref2) {
  var media = _ref2.theme.media;
  return media.medium(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    text-align: right;\n  "])));
});

var Footer = _styledComponents.default.footer.withConfig({
  displayName: "Footer",
  componentId: "quaplv-2"
})(["align-items:center;background:rgba(255,255,255,0.8);bottom:", ";box-shadow:0 2px 8px 0 rgba(0,0,0,0.1);display:flex;flex-direction:column;height:", ";justify-content:center;line-height:", ";padding-left:", ";padding-right:", ";position:fixed;right:0;width:100%;z-index:100;", ";", ";"], function (props) {
  return props.cobrowse ? '60px' : 0;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.immersiveFlow.immersiveFlowMobileHeight;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.immersiveFlow.immersiveFlowMobileHeight;
}, (0, _polished.rem)('18px'), (0, _polished.rem)('18px'), function (_ref5) {
  var _ref5$theme = _ref5.theme,
      media = _ref5$theme.media,
      immersiveFlow = _ref5$theme.immersiveFlow;
  return media.medium((0, _styledComponents.css)(["height:", ";line-height:", ";padding-left:", ";padding-right:", ";"], immersiveFlow.immersiveFlowHeight, immersiveFlow.immersiveFlowHeight, function (props) {
    return props.theme.spacing.large;
  }, function (props) {
    return props.theme.spacing.large;
  }));
}, function (_ref6) {
  var media = _ref6.theme.media;
  return media.large((0, _styledComponents.css)(["padding-left:", ";padding-right:", ";"], function (props) {
    return props.theme.spacing.xxlarge;
  }, function (props) {
    return props.theme.spacing.xxlarge;
  }));
});

var BackMobileButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "Footer__BackMobileButton",
  componentId: "quaplv-3"
})(["background-color:", ";margin-right:", ";text-decoration:none;", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.neutral.white;
}, function (props) {
  return props.theme.spacing.small;
}, function (_ref8) {
  var media = _ref8.theme.media;
  return media.medium((0, _styledComponents.css)(["display:none;"]));
});
var BackButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "Footer__BackButton",
  componentId: "quaplv-4"
})(["display:none;padding-right:", ";text-decoration:none;", ";"], (0, _polished.rem)('20px'), function (_ref9) {
  var media = _ref9.theme.media;
  return media.medium((0, _styledComponents.css)(["display:block;"]));
});

var ButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "Footer__ButtonContainer",
  componentId: "quaplv-5"
})(["display:", ";margin-right:8px;width:7.5rem;", ";"], function (_ref10) {
  var hideOnDesktop = _ref10.hideOnDesktop;
  return hideOnDesktop ? 'none' : 'block';
}, function (_ref11) {
  var hideOnMobile = _ref11.hideOnMobile,
      media = _ref11.theme.media;
  return media.smallMedium((0, _styledComponents.css)(["display:", ";"], hideOnMobile ? 'none' : 'block'));
});

var Content = _styledComponents.default.div.withConfig({
  displayName: "Footer__Content",
  componentId: "quaplv-6"
})(["align-items:center;display:flex;flex-direction:row;height:100%;justify-content:center;width:100%;"]);

var Buttons = (0, _styledComponents.default)(Content).withConfig({
  displayName: "Footer__Buttons",
  componentId: "quaplv-7"
})(["", ";"], function (_ref12) {
  var media = _ref12.theme.media;
  return media.medium((0, _styledComponents.css)(["justify-content:flex-end;"]));
});

var ImmersiveFlowFooter = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ImmersiveFlowFooter, _React$Component);

  var _super = _createSuper(ImmersiveFlowFooter);

  function ImmersiveFlowFooter(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ImmersiveFlowFooter);
    _this = _super.call(this, props);
    _this.renderContinueButton = _this.renderContinueButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderBackButton = _this.renderBackButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderButtonDiv = _this.renderButtonDiv.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderContentDiv = _this.renderContentDiv.bind((0, _assertThisInitialized2.default)(_this));
    _this.checkCobrowse = _this.checkCobrowse.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ImmersiveFlowFooter, [{
    key: "renderContinueButton",
    value: function renderContinueButton() {
      var _this$props = this.props,
          continueText = _this$props.continueText,
          continueOnClick = _this$props.continueOnClick,
          continueWorking = _this$props.continueWorking,
          continueDisabled = _this$props.continueDisabled;

      if (continueOnClick && continueText) {
        return /*#__PURE__*/_react.default.createElement(_Button.default, {
          "data-test-id": "immersive-flow-continue",
          id: "IF-continue-btn",
          onClick: continueOnClick,
          working: continueWorking,
          disabled: continueDisabled
        }, continueText);
      }

      return null;
    }
  }, {
    key: "renderBackButton",
    value: function renderBackButton() {
      var _this$props2 = this.props,
          backText = _this$props2.backText,
          backOnClick = _this$props2.backOnClick;

      if (backText && backOnClick) {
        return /*#__PURE__*/_react.default.createElement(BackButton, {
          "data-test-id": "immersive-flow-back",
          id: "IF-back-btn",
          onClick: backOnClick,
          variant: "tertiary"
        }, backText);
      }

      return null;
    }
  }, {
    key: "renderBackButtonMobile",
    value: function renderBackButtonMobile() {
      var _this$props3 = this.props,
          backText = _this$props3.backText,
          backOnClick = _this$props3.backOnClick;

      if (backText && backOnClick) {
        return /*#__PURE__*/_react.default.createElement(BackMobileButton, {
          onClick: backOnClick,
          variant: "secondary"
        }, backText);
      }

      return null;
    }
  }, {
    key: "renderButtonDiv",
    value: function renderButtonDiv() {
      var _this$props4 = this.props,
          backText = _this$props4.backText,
          backOnClick = _this$props4.backOnClick,
          continueOnClick = _this$props4.continueOnClick,
          continueText = _this$props4.continueText;
      return /*#__PURE__*/_react.default.createElement(Buttons, null, backText && backOnClick ? /*#__PURE__*/_react.default.createElement(ButtonContainer, {
        hideOnMobile: true
      }, this.renderBackButton()) : null, backText && backOnClick ? /*#__PURE__*/_react.default.createElement(ButtonContainer, {
        hideOnDesktop: true
      }, this.renderBackButtonMobile()) : null, continueOnClick && continueText ? /*#__PURE__*/_react.default.createElement(ButtonContainer, null, this.renderContinueButton()) : null);
    }
  }, {
    key: "renderContentDiv",
    value: function renderContentDiv() {
      if (this.props.children) {
        return /*#__PURE__*/_react.default.createElement(Content, null, this.props.children);
      }

      return null;
    }
  }, {
    key: "checkCobrowse",
    value: function checkCobrowse() {
      return typeof window !== 'undefined' && window && window.COBROWSE && window.COBROWSE.inSession();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(Footer, {
        cobrowse: this.checkCobrowse(),
        className: this.props.className
      }, /*#__PURE__*/_react.default.createElement(FooterRow, null, /*#__PURE__*/_react.default.createElement(FooterCol, {
        small: 12
      }, this.renderButtonDiv(), this.renderContentDiv())));
    }
  }]);
  return ImmersiveFlowFooter;
}(_react.default.Component);

ImmersiveFlowFooter.defaultProps = {};
ImmersiveFlowFooter.propTypes = {
  /** Allow for additional custom content in the footer.  Will compete for footer space is supplied with traditional continue/back buttons. */
  children: _propTypes.default.node,

  /** Custom class for Footer. */
  className: _propTypes.default.string,

  /** Text in right button. */
  continueText: _propTypes.default.string,

  /** Event handler for continue button. */
  continueOnClick: _propTypes.default.func,

  /** Is loading for continue button. */
  continueWorking: _propTypes.default.bool,

  /** Is the right button disabled. */
  continueDisabled: _propTypes.default.bool,

  /** Text for back button. */
  backText: _propTypes.default.string,

  /** Event handler for back button. */
  backOnClick: _propTypes.default.func
};
var _default = ImmersiveFlowFooter;
exports.default = _default;
//# sourceMappingURL=Footer.js.map